import React from "react"

export default function SettingsPage() {
  return (
    <div style={{ padding: 24 }}>
      <h1>Configuración</h1>
      <p>Aquí irá configuración clínica, sillas, doctores y tratamientos.</p>
    </div>
  )
}